import script from "./RcCounterBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcCounterBadge.vue?vue&type=script&setup=true&lang=ts"

import "./RcCounterBadge.vue?vue&type=style&index=0&id=0ee56b26&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ee56b26"]])

export default __exports__